import React from 'react';
import cx from 'classnames';

import routeDetails from 'app/constants/routeDetails';

import Link from 'app/components/Link';

import styles from './styles.css';

const Nav = ({ isOpen, onNavClick }) => {
  const navBarClasses = cx({
    [styles.navBarContainer]: true,
    [styles.navBarContainerIsOpen]: isOpen,
  });

  const navClasses = cx({
    [styles.nav]: true,
    [styles.navIsOpen]: isOpen,
  });

  return (
    <div className={styles.container}>
      <button className={navBarClasses} onClick={onNavClick}>
        <span className={styles.navBarItem} />
        <span className={styles.navBarItem} />
        <span className={styles.navBarItem} />
      </button>
      <nav className={navClasses}>
        <Link
          className={styles.link}
          to={routeDetails.FORMULA.url}
          label={routeDetails.FORMULA.title}
          onClick={onNavClick}
        />
        <Link
          className={styles.link}
          to={routeDetails.CONTACT.url}
          label={routeDetails.CONTACT.title}
          onClick={onNavClick}
        />
      </nav>
    </div>
  );
};

export default Nav;



// WEBPACK FOOTER //
// ./src/components/Header/Nav/index.js